import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PageNotFoundComponent } from './auth/page-not-found/page-not-found.component';

export const routes: Routes = [
	{
		path: '',
		loadChildren: '../app/portal/portal.module#PortalModule'
	},
	{
		path: 'terms',
		loadChildren: '../app/terms/terms.module#TermsModule'
	},
	{
		path: 'privacy',
		loadChildren: '../app/privacy/privacy.module#PrivacyModule'
	},
	{
		path: '**',
		component: PageNotFoundComponent
	}
];


@NgModule({
  imports: [
  	RouterModule.forRoot(routes)
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
